import { Injectable } from '@angular/core';

import { LogService } from '@oa/shared-core';

// import Geohash from 'latlon-geohash';

/**
 * 
 */
@Injectable()
export class GeoHashService {

  
  constructor(readonly log:LogService) {

   }


  /**
    * Encode a latitude longitude as a geohash
   * @param lat 
   * @param lon 
   * @param precision 
   */
   public encode(lat:number,lon:number, precision?:number) {   
     
      // if (lat && lon){
      //   return Geohash.encode(lat,lon,precision); 
      // }

      return null;    
   }

}
